















































































































import Vue, { PropType } from "vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { OrderDetailsInterface } from "@/model/components/manuscript/OrderDetailsInterface.ts";
import { InputLogoFileInterface } from "@/model/components/InputLogoFileInterface.ts";
import InputLogoFile from "@/components/InputLogoFile.vue";
import { numberOfPrintsLists, NumberOfPrints } from "@/model/numberOfPrints.ts";

// eslint-disable-next-line
function requiredImageData(this: any) {
  return this.logoFile1 || this.logoFile2;
}

export default Vue.extend({
  name: "OrderDetails",

  mixins: [validationMixin],

  components: {
    InputLogoFile
  },

  props: {
    orderDetails: {
      type: Object as PropType<OrderDetailsInterface>
    },
    nth: {
      type: Number
    }
  },

  data: () => {
    return {
      errors: {
        logoFile1: "",
        logoFile2: ""
      }
    };
  },

  validations: {
    numberOfPrints: { required },
    imageData: { requiredImageData: requiredImageData }
  },

  computed: {
    numberOfPrints(): number | undefined {
      return this.orderDetails.numberOfPrints;
    },
    logoFile1(): string {
      return this.orderDetails.logoFile1;
    },
    logoFile2(): string {
      return this.orderDetails.logoFile2;
    },
    file1(): InputLogoFileInterface {
      return {
        label: `sys-${this.nth}th-logo-file01`,
        filename: this.orderDetails.logoFile1,
        original: this.orderDetails.logoFile1Original,
        error: this.errors.logoFile1
      };
    },
    file2(): InputLogoFileInterface {
      return {
        label: `sys-${this.nth}th-logo-file02`,
        filename: this.orderDetails.logoFile2,
        original: this.orderDetails.logoFile2Original,
        error: this.errors.logoFile2
      };
    },
    numberOfPrintsLists(): NumberOfPrints[] {
      return numberOfPrintsLists;
    },
    isWithBth(): boolean {
      return this.nth > 1;
    }
  },

  methods: {
    updateNumberOfPrints(value: number, label: string): void {
      this.$v.numberOfPrints.$touch();
      this.updateOrderDetails(value, label);
    },
    updateOrderDetails(value: number | string, label: string): void {
      this.$emit(
        "updateOrderDetails",
        Object.assign({}, this.orderDetails, { [label]: value }),
        this.nth
      );
    },
    onLogoFile1Updated(payload: InputLogoFileInterface): void {
      this.$v["imageData"].$touch();
      this.errors.logoFile1 = payload.error;
      setTimeout(() => {
        this.errors.logoFile1 = "";
      }, 5000);
      this.$emit(
        "updateOrderDetails",
        Object.assign({}, this.orderDetails, {
          logoFile1: payload.filename,
          logoFile1Original: payload.original
        }),
        this.nth
      );
    },
    onLogoFile2Updated(payload: InputLogoFileInterface): void {
      this.$v["imageData"].$touch();
      this.errors.logoFile2 = payload.error;
      setTimeout(() => {
        this.errors.logoFile2 = "";
      }, 5000);
      this.$emit(
        "updateOrderDetails",
        Object.assign({}, this.orderDetails, {
          logoFile2: payload.filename,
          logoFile2Original: payload.original
        }),
        this.nth
      );
    },
    removeNthBtnClick(): void {
      this.$emit("removeNthBtnClick", { nth: this.nth });
    }
  }
});
